// Fancybox
{
  Fancybox.bind('[data-fancybox]', {
    // Custom options for all galleries
  });   
}

// Click to scroll Seciton
{
  function JumpSection(element) {
    let elementTop = element.offsetTop;
    let headerHeight = document.querySelector('.shopify-section--header').offsetHeight;
    console.log(element)
    Jump(element, {
      duration: 1500,
      offset: -headerHeight,
      callback: undefined,
      a11y: false
    });
    /*window.scrollTo({
      top: (elementTop - 80),
      behavior: "smooth",
    });*/
    window.sessionStorage.removeItem('sctollToSection');
  }
  let sctollToSection = window.sessionStorage.getItem('sctollToSection');
  if(sctollToSection){
    let element = (window.matchMedia('(max-width: 699px)').matches) ? (document.querySelector(`${sctollToSection}-mobile`) || document.querySelector(sctollToSection) ) : document.querySelector(sctollToSection);
    if(element) JumpSection(element);
  }
  document.querySelectorAll('[data-scroll-section]').forEach(button => {
    button.addEventListener('click',function(event) {
      event.preventDefault();
      let newURL = new URL(button.href);
      let section = (window.matchMedia('(max-width: 699px)').matches) ? (document.querySelector(`${newURL.hash}-mobile`) || document.querySelector(newURL.hash) ) : document.querySelector(newURL.hash);
      let currentPage = window.location;
      if(newURL.pathname == currentPage.pathname){
        if(section){
          if(this.closest('details[is=mega-menu-disclosure]')){
            this.closest('details[is=mega-menu-disclosure]').querySelector('summary').click();
          }
          if(this.closest('navigation-drawer')) this.closest('navigation-drawer').removeAttribute('open');
          JumpSection(section);
        }else{
          window.location.href = newURL.pathname;
        }
      }else{
        window.sessionStorage.setItem('sctollToSection',newURL.hash);
        window.location.href = newURL.pathname; 
      }
    });
  })
}

// Custom Slider Cards for Home Page
{
  function initCustomSlider(section) {
    const slider = section.querySelector('.custom-slider-cards__track');
    const progressBar = section.querySelector('.custom-slider-progress__bar');
    
    if (!slider || !progressBar) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse Drag Events
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX; // Simply capture global X
      scrollLeft = slider.scrollLeft;
      e.preventDefault(); // Prevents text selection
    });

    slider.addEventListener('mouseleave', () => {
      if(isDown) { // Only checking if it was down
        isDown = false;
        slider.classList.remove('active');
      }
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX;
      const walk = (x - startX); // 1:1 scroll for smoothness
      slider.scrollLeft = scrollLeft - walk;
    });

    // Progress Bar Update
    const updateProgressBar = () => {
      const scrollPercentage = (slider.scrollLeft / (slider.scrollWidth - slider.clientWidth)) * 100;
      progressBar.style.width = Math.min(Math.max(scrollPercentage, 0), 100) + '%';
    };

    slider.addEventListener('scroll', updateProgressBar);
    window.addEventListener('resize', updateProgressBar);
    // Initial call
    updateProgressBar();
  }

  // Initialize all existing sliders
  document.querySelectorAll('.custom-slider-section').forEach(function(section) {
    initCustomSlider(section);
  });

  // Handle Shopify Theme Editor events
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('custom-slider-section')) {
      initCustomSlider(event.target);
    }
  });
}

// Product Gallery Draggable Slider (Appended)
{
  function initProductDragSlider(gallery) {
    const slider = gallery.querySelector('.product-gallery__media-list, .product-gallery__media-list-custom');
    const progressBar = gallery.querySelector('.custom-slider-progress__bar');

    if (!slider || !progressBar) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // Prevent default browser drag behavior on images
    slider.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('active');
      startX = e.pageX;
      scrollLeft = slider.scrollLeft;

      // Disable scroll snap for smooth dragging
      slider.style.scrollBehavior = 'auto';
      slider.style.scrollSnapType = 'none';

      e.preventDefault(); 
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX;
      const walk = (x - startX);
      slider.scrollLeft = scrollLeft - walk;
    });

    const updateProgressBar = () => {
      const scrollPercentage = (slider.scrollLeft / (slider.scrollWidth - slider.clientWidth)) * 100;
      progressBar.style.width = Math.min(Math.max(scrollPercentage, 0), 100) + '%';
    };

    slider.addEventListener('scroll', updateProgressBar);
    window.addEventListener('resize', updateProgressBar);
    updateProgressBar();
  }

  document.addEventListener('DOMContentLoaded', () => {
     document.querySelectorAll('.product-gallery').forEach(gallery => {
       initProductDragSlider(gallery);
     });
  });
  
  document.addEventListener('shopify:section:load', function(event) {
    const productGallery = event.target.querySelector('.product-gallery');
    if (productGallery) {
      initProductDragSlider(productGallery);
    }
  });
}